<script>
    import {Link} from 'svelte-routing';
    import {api, api_internal, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';
    import Header from '../components/Header.svelte';
    import ImageCMS from '../components/ImageCMS.svelte';
    import Image from '../components/Image.svelte';
    import LoadingTabs from '../components/LoadingTabs.svelte';

    const user = store('credentials', 'appUserAuth');

    export let id = '';

    const fetchEvent = (async () => {
        let result = await api('getEvent', {idEvent: id, emailEventMember: $user.email});
        let data = result.data;
        
        if (data.fileSummary) {
            data.fileSummary = data.fileSummary.split(',');
        }
        
        return data ? data : [];
    })();
    const tab = sessionStorage.getItem('tab-event-' + id) ? sessionStorage.getItem('tab-event-' + id) : 0;
    const saveTab = (name) => sessionStorage.setItem('tab-event-' + id, name);
    const showing = async (list) => {
        let event = await fetchEvent,
            tests = event.tests;
    
        return list
            .map((item) => {
                item.content.test = null;
                if (item.content.full) {
                    item.content.full = parseB64Code(item.content.full);
                    item.content.test = tests.find((el) => el.idTest === item.content.full.id) || null;
                }
            
                return item;
            })
            .filter((item) => {
                if (item.content.full) {
                    let data = item.content.full;
                
                    if (data && data.product) {
                        return (+data.product) === (+event.idProd);
                    }
                }
            
                return false;
            })
            .sort((a, b) => {
                let dateA = Date.parse(a.date.replace(' ', 'T'));
                let dateB = Date.parse(b.date.replace(' ', 'T'));
            
                return dateB - dateA;
            });
    };
    
    const fetchCategories = (async () => {
        let result = await api_internal('publication/category', {parent: '7de10594-6570-4996-a1fd-f1b2f7826106'});
        
        if (result && result.data) {
            let output = [];
            
            for (const category of result.data) {
                let list = await api_internal('publication', {category: category.uuid});
                
                if (list && list.data) {
                    list = await showing(list.data);
    
                    if (list.length) {
                        category.list = list;
                        output.push(category);
                    }
                }
            }
            
            return output;
        }
        
        return [];
    })();
    
    let url = '';
</script>

<TopMenu title="Материалы">
    <TopMenu_BackBtn slot="back" href="/events/view/{id}" />
</TopMenu>

<div id="appCapsule">
    {#await fetchEvent}
        <Header />
        
        <LoadingTabs />
    {:then event}
        <Header title="Материалы" subtitle="{event.nameProd}" />
    
        {#if event.start && event.start.toString() === '1'}
            {#await fetchCategories}
                <LoadingTabs />
            {:then data}
                <div class="section full">
                    <div class="wide-block transparent p-0">
                        <ul class="nav nav-tabs lined iconed" role="tablist">
                            {#each data as {uuid, title}, i}
                                <li class="nav-item" on:click={() => saveTab(i)}>
                                    <a class="nav-link {i == tab ? 'active' : ''}" data-bs-toggle="tab" href="#tab-{i}" role="tab" aria-selected="false">
                                        {title}
                                    </a>
                                </li>
                            {/each}
        
                            {#if event.guide.opis || (event.fileSummary ? event.fileSummary : []).length || (event.guide.files ? event.guide.files : []).length}
                                <li class="nav-item" on:click={() => saveTab('guide')}>
                                    <a class="nav-link {data.length === 0 || 'guide' === tab ? 'active' : ''}" data-bs-toggle="tab" href="#tab-guide" role="tab" aria-selected="false">
                                        Саммари
                                    </a>
                                </li>
                            {/if}
                        </ul>
                    </div>
                </div>
        
                <div class="tab-content">
                    {#each data as {uuid, title, list}, i}
                        <div class="tab-pane fade {i == tab ? 'active show' : ''}" id="tab-{i}" role="tabpanel">
                            <div class="section">
                                <div class="row">
                                    {#if list.length }
                                        {#each list as {uuid, title, content, files}, i}
                                            <div class="col-12 col-md-6 col-lg-4">
                                                <div class="card my-2 mx-0">
                                                    <Link to="/events/view/{id}/tests/view/{uuid}">
                                                        {#if files && files[0]}
                                                            <ImageCMS src="{files[0].path.middle}" class="card-img-top" alt="{title}" style="height: 300px;object-fit: cover;object-position: center center;" />
                                                        {:else}
                                                            <Image src="/img/poll.jpg" class="card-img-top" alt="{title}" style="height: 300px;object-fit: cover;object-position: center center;" />
                                                        {/if}
                            
                                                        {#if content.test !== null}
                                                            <div class="chip chip-media" style="position: absolute; right: 10px; top: 10px; box-shadow: 0 3px 6px 0 rgb(0 0 0 / 10%), 0 1px 3px 0 rgb(0 0 0 / 8%);">
                                                                <i class="chip-icon bg-primary">
                                                                    <ion-icon name="ribbon-outline"></ion-icon>
                                                                </i>
                                                                {#if !content.test.state}
                                                                    <span class="chip-label">{content.test.test} МИИНок</span>
                                                                {:else}
                                                                    <span class="chip-label">Пройдено</span>
                                                                {/if}
                                                            </div>
                                                        {/if}
                                                    </Link>
                                                    <div class="card-body">
                                                        <h3>{title}</h3>
                                                    </div>
                                                    <div class="card-footer">
                                                        {#if content.test !== null && content.test.state}
                                                            <div class="alert alert-outline-secondary fade show mb-2 text-center" role="alert">
                                                                {content.test.state}
                                                            </div>
                                                        {/if}
                            
                                                        <Link to="/events/view/{id}/tests/view/{uuid}" class="btn {content.test === null ? 'btn-primary' : 'btn-secondary'} btn-block">
                                                            {content.test === null ? 'Пройти' : 'Пройти снова'}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        {/each}
                                    {:else}
                                        <div class="error-page">
                                            <h1 class="title">Материалов нет</h1>
                                            <div class="text mb-5">
                                                Попробуйте другую вкладку.
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/each}
        
                    {#if event.guide.opis || (event.fileSummary ? event.fileSummary : []).length || (event.guide.files ? event.guide.files : []).length}
                        <div class="tab-pane fade {data.length === 0 || 'guide' === tab ? 'active show' : ''}" id="tab-guide" role="tabpanel">
                            <div class="section">
                                <div class="row">
                                    <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                                        <div class="card mt-3">
                                            {#if event.guide.opis.trim().length}
                                                <div class="card-body">
                                                    {@html event.guide.opis
                                                        .replaceAll('<a', '<a target="_blank"')
                                                        .replaceAll('<font', '<span')
                                                        .replaceAll('</font>', '</span>')
                                                        .replaceAll('font-', 'font-1-')
                                                    }
                                                </div>
                                            {/if}
                                            <div class="card-footer border-0 p-0">
                                                <ul class="listview image-listview border-0">
                                                    {#each (event.fileSummary ? event.fileSummary : []) as file}
                                                        <li>
                                                            <div class="item">
                                                                <div class="in">
                                                                    <div style="overflow-x: hidden">{file}</div>
                                                                    <button type="button" class="btn btn-link btn-sm" data-bs-toggle="modal" data-bs-target="#modal-content" on:click={() => {url = encodeURI(file);}}>
                                                                        Открыть
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    {/each}
                                                    {#each (event.guide.files ? event.guide.files : []) as file}
                                                        <li>
                                                            <div class="item">
                                                                <div class="in">
                                                                    <div style="overflow-x: hidden">{file}</div>
                                                                    <button type="button" class="btn btn-link btn-sm" data-bs-toggle="modal" data-bs-target="#modal-content" on:click={() => {url = encodeURI(file);}}>
                                                                        Открыть
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    {/each}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            
                        <div class="modal fade modalbox" id="modal-content" data-bs-backdrop="static" tabindex="-1" role="dialog" style="display: none;" aria-modal="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        {#if url.includes('.pdf') || url.includes('.png') || url.includes('.jpg') || url.includes('.jpeg') || url.includes('.gif')}
                                            <a href="{'https://225304.selcdn.ru/miin/' + url}" target="_blank" class="h5 modal-title">Скачать материал <ion-icon name="download-outline"></ion-icon></a>
                                        {:else}
                                            <h5 class="modal-title">Просмотр материала</h5>
                                        {/if}
                                        
                                        <a href="#" data-bs-dismiss="modal" on:click={() => {url = '';}}>Закрыть</a>
                                    </div>
                                    <div class="modal-body p-0">
                                        {#if url !== ''}
                                            {#if url.includes('.pdf')}
                                                <iframe src="https://drive.google.com/viewerng/viewer?embedded=true&url={'https://225304.selcdn.ru/miin/' + url}" class="d-block mx-auto" frameborder="0" scrolling="yes" style="width: 100%; height: 100%; max-width: 800px;"></iframe>
                                            {:else if url.includes('youtu.be')}
                                                <iframe src="https://www.youtube.com/embed/{url.replace('https://youtu.be/', '')}" class="d-block mx-auto" frameborder="0" style="width: 100%; height: 100%; max-width: 800px;"></iframe>
                                            {:else if url.includes('rutube.ru')}
                                                <iframe src="{url.replace('video', 'play/embed')}" class="d-block mx-auto" frameborder="0" style="width: 100%; height: 100%; max-width: 800px;"></iframe>
                                            {:else}
                                                <ImageCMS src="{'https://225304.selcdn.ru/miin/' + url}" class="d-block mx-auto" alt="Картинка" style="width: 100%; height: 100%; max-width: 800px;object-fit: contain;object-position: center center;" />
                                            {/if}
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
            {/await}
        {:else}
            <div class="section full">
                <div class="row">
                    <div class="col-12">
                        <div class="error-page">
                            <h1 class="title">Материалы недоступны</h1>
                            <div class="text mb-5">
                                Материалы будут доступны после начала мероприятия.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
    {/await}
</div>

